import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectBudgetGroupDetail from '@app/views/ProjectBudgetGroup/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectBudgetGroupDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
